import { useTranslation } from 'react-i18next';
import { useState, useRef, ComponentType } from 'react';
import { ButtonProps } from '@mui/material';
import { Tooltip } from '@dtsl/react';
import DeviceSelectionDialog from '../../../DeviceSelectionDialog/DeviceSelectionDialog';
import SettingsIcon from '../../../../icons/SettingsIcon';

export default function SettingsMenu({ CustomToggleButton }: { CustomToggleButton: ComponentType<ButtonProps> }) {
  const { t } = useTranslation();
  const [deviceSettingsOpen, setDeviceSettingsOpen] = useState(false);
  const { CustomToggleButton: ButtonComponent } = { CustomToggleButton };

  const anchorRef = useRef<HTMLButtonElement>(null);

  return (
    <>
      <Tooltip text={t('ROOM.OPTIONS')} placement="top">
        <ButtonComponent
          id="video-calls-settings"
          ref={anchorRef}
          onClick={() => setDeviceSettingsOpen(true)}
          startIcon={<SettingsIcon />}
        ></ButtonComponent>
      </Tooltip>
      <DeviceSelectionDialog
        open={deviceSettingsOpen}
        onClose={() => {
          setDeviceSettingsOpen(false);
        }}
      />
    </>
  );
}
